import { createContext, useState } from "react";
import { User } from "../types/models/User";

interface ProfileContextProps {
  profile: User | undefined;
  setProfile: React.Dispatch<React.SetStateAction<User | undefined>>;
  toggleProfileNotification: () => void;
  toggleProfile2FA: () => void;
}

export const ProfileContext = createContext<ProfileContextProps | undefined>(undefined);

export const ProfileProvider = (props: { children: React.ReactNode }) => {
  // Profile State
  const [profile, setProfile] = useState<User | undefined>({});

  // Toggle Profile Notifcation State
  const toggleProfileNotification = () => {
    setProfile((prev) => ({ ...prev, is_enable_notif: !profile?.is_enable_notif }));
  };

  // Toggle Profile 2FA state
  const toggleProfile2FA = () => {
    setProfile((prev) => ({ ...prev, is_enabled_2fa: !profile?.is_enabled_2fa }));
  };

  return (
    <ProfileContext.Provider value={{ profile, setProfile, toggleProfileNotification, toggleProfile2FA }}>{props.children}</ProfileContext.Provider>
  );
};
